module.exports = __webpack_public_path__ + "media/images/tax-credit-artwork-4201f120.svg";